import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAPIGetCustomerDetail } from "../api/api-get-customer-detail";
import CustomerDetailMainProfile from "./CustomerDetailMainProfile";

import CustomerHistory from "./CustomerHistory";

const CustomerDetailReportMain = () => {
  const { code } = useParams();
  const {
    data,
    loading,
    error,
    fetchData,
    filterValue,
    setFilterValue,
    customerCode,
    setCustomerCode,
  } = useAPIGetCustomerDetail();

  useEffect(() => {
    if (code) {
      setCustomerCode(code);
      fetchData({ code });
    }
  }, [code]);

  useEffect(() => {
    fetchData({ code });
  }, [filterValue]);

  return (
    <div className="col-center-start p-4 gap-4 w-full">
      <CustomerDetailMainProfile data={data} loading={loading} error={error} />
      <CustomerHistory
        data={data}
        loading={loading}
        error={error}
        filterValue={filterValue}
        setFilterValue={setFilterValue}
      />
    </div>
  );
};

export default CustomerDetailReportMain;
